import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  submitButton: {
    marginTop: "20px",
  },
}));
